export default __webpack_public_path__ + "static/media/Primarylogomark_purple_black_white-03.0e7af16d.webp";